import { Attribute } from 'proto/Accommodation/Attributes';
import { ViewType } from 'proto/Offer/Accommodation/ViewType';

export const beachListArray = [
    Attribute.DirectBeachAccess,
    Attribute.GentlySlopingSandyBeach,
    Attribute.SandyBeach,
    Attribute.HotelNearTheBeach,
];
export const hotelAmenitiesAndServiceListArray = [
    Attribute.Pool,
    Attribute.FreeWLAN,
    Attribute.Wellness,
    Attribute.WaterSlide,
    Attribute.GreatSportsOffer,
    Attribute.ParkingSpacesAvailable,
    Attribute.IndoorPool,
    Attribute.HeatedPool,
    Attribute.Internet,
    Attribute.Restaurant,
    Attribute.HandicappedAccessible,
    Attribute.FreeParking,
    Attribute.LaundryService,
];
export const childOfferListArray = [
    Attribute.ChildrensPool,
    Attribute.KidsDisco,
    Attribute.GermanSpeakingEntertainmentForKids,
    Attribute.ChildrensPlayground,
    Attribute.BabyCot,
    Attribute.ChildrensBuffet,
    Attribute.SportOffersForChildren,
    Attribute.BabySitting,
    Attribute.BuggyRent,
];
export const ambienceListArray = [
    Attribute.Club,
    Attribute.FamilyHoliday,
    Attribute.NiceSmallFamilyRun,
    Attribute.AdultsOnly,
    Attribute.Deluxe,
];

export const wellnessListArray = [
    Attribute.Sauna,
    Attribute.Ayurveda,
    Attribute.RelaxationOffersForBodyAndSoul,
    Attribute.Cosmetic,
    Attribute.Massages,
    Attribute.BeautyFarm,
    Attribute.Thalasso,
];

export const viewTypeListArray = [ViewType.SeaView, ViewType.LateralSeaView];

export const sportOfferListArray = [
    Attribute.Fitness,
    Attribute.Diving,
    Attribute.Golf,
    Attribute.Tennis,
    Attribute.Cycling,
    Attribute.Surfing,
    Attribute.Kitesurfing,
    Attribute.SwimSchool,
    Attribute.WaterSports,
    Attribute.Windsurfing,
    Attribute.Wingfoiling,
    Attribute.Sailing,
    Attribute.Hiking,
    Attribute.HorseRiding,
    Attribute.SoccerSchool,
    Attribute.Squash,
    Attribute.WinterSports,
];
